import styled from 'styled-components'
import { SIZES } from '../../../constants'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 16px 0 24px;
  
  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    gap: 12px;
    flex-direction: row;
  }
`

export const Image = styled.img`
  width: 100%;
  max-width: 230px;
  max-height: 140px;
  object-fit: cover;
  border-radius: 4px;
`

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Paragraph = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.vyber.color};
  overflow: hidden;
  max-height: 4rem;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3; 
  text-overflow: ellipsis;
  display: -webkit-box;
`

export const Title = styled.div`
  color: ${props => props.theme.vyber.color};
  line-height: 21px;
  font-weight: 700;
  font-size: 16px;

  &:hover {
    text-decoration: underline;
  }
`

export const ButtonTheme = styled.span`
  background: ${props => props.theme.vyber.button};
  border-radius: 10px;
  color: ${props => props.theme.vyber.color};
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  width: 142px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.vyber.button};
  padding: 9px 24px;
  
  &:hover {
    background-color: ${props => props.theme.vyber.buttonHover};
    border: 1px solid ${props => props.theme.vyber.buttonHover};
    color: ${props => props.theme.vyber.color};
    text-decoration: none;
  }
`

export const ArrowRight = styled.span`
  display: inline-block;
  border-right: 2px solid ${props => props.theme.vyber.arrowButton};
  border-bottom: 2px solid ${props => props.theme.vyber.arrowButton};
  width: 10px; height: 10px;
  transform: rotate(-45deg);
  position: relative;
  left: 5px;
  top: 0;
`

export const Link = styled.a`
  &:hover {
    text-decoration: none;
  }
`
